/**
 * The site's browser script. Every page gets the subscribe popups' Copy,
 * tabs and modal, suggestions in its search boxes, and fixture times in the
 * visitor's own time zone; the home page also gets the live "Next up"
 * countdown and the rows' arrows, and competition, league and schedule
 * pages keep their fixtures (and a competition's countdown) current. Everything works without it: the pages are fully
 * rendered on the server.
 */
import { startCountdown } from "./countdown.ts";
import { setUpSubscribePopups } from "./dialog.ts";
import { startFixtureList } from "./fixtures.ts";
import { setUpRails } from "./rail.ts";
import { setUpSearch } from "./search.ts";
import { localiseTimes } from "./times.ts";

setUpSubscribePopups();
setUpSearch();
localiseTimes();
setUpRails();
startCountdown();
startFixtureList();
